import { appointmentQuestionsCopy } from '../data/appointmentQuestionsCopy.js';
import { professionalTranslationFor } from '../data/professionalTranslationRuntime.js';
import { sourceRevision } from './translationAssurance.js';

// Printing appointment questions is patient-facing even though its language
// pack predates i18next and is stored as an array in a JavaScript module.
export function buildAppointmentQuestionsTranslationRows(locale) {
  const english = appointmentQuestionsCopy('en');
  const current = appointmentQuestionsCopy(locale);
  return Object.entries(english).map(([key, sourceText]) => {
    const id = 'appointmentQuestions:' + key;
    const corrected = professionalTranslationFor(locale, 'appointmentQuestions', key);
    return { id, namespace: 'appointmentQuestions', path: key, contentArea: 'core_ui',
      sourceText, sourceRevision: sourceRevision(id, sourceText),
      originalText: current[key] || '',
      provenance: corrected ? 'professionally approved correction' : 'legacy appointment print translation',
      publicationTarget: 'locale' };
  });
}
